module.exports = __webpack_public_path__ + "img/view-stacked.c10e6d35.svg";